export const ROOT = "/admin/lucky-draw";
export const LUCKY_DRAW_PARTICIPANT = `${ROOT}/view/:luckyDrawID/`;
